import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const tryAndBuyStyle = (theme) => ({
	gridWrapper: {
		justifyContent: 'flex-start',
		flexDirection: 'column',
	},
	headerWrapper: {
		marginBottom: 10,
	},
	wrapper: {
		backgroundColor: whiteColor,
		borderRadius: 4,
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'row',
		padding: '24px',
		marginTop: '15px',
		alignItems: 'baseline',
		[theme.breakpoints.down('sm')]: {
			'&::after': {
				content: '""',
				transform: 'rotate(45deg)',
				display: 'block',
				width: '10px',
				height: '10px',
				borderTop: '2px solid black',
				borderRight: '2px solid black',
			},
		},
		[theme.breakpoints.up('sm')]: {
			pointerEvents: 'none',
			'& .MuiButtonBase-root': {
				pointerEvents: 'auto',
			},
		},
	},
	tryNowButton: {
		textAlign: 'center',
		width: 108,
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	serviceName: {
		marginRight: 'auto',
	},
	serviceWrapper: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'column',
		marginRight: 'auto',
	},
	heading: {
		margin: 0,
	},
});

export default tryAndBuyStyle;
